var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61 35C62.9396 35 64 36 64 38V42C64 44 62.9396 45 61 45",
    stroke: "#000E4B",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2935 35.8333C28.2935 38.5 28.2935 41.5 28.2935 44.1667",
    stroke: "#000E4B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5852 35.8333C35.5852 38.5 35.5852 41.5 35.5852 44.1667",
    stroke: "#000E4B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5 55H31.5C21.5 55 19 52.8571 19 44.2857V35.7143C19 27.1429 21.5 25 31.5 25H46.5C56.5 25 59 27.1429 59 35.7143V44.2857C59 52.8571 56.5 55 46.5 55Z",
    stroke: "#000E4B",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery50);
export default __webpack_public_path__ + "static/media/battery-50.c8a2023d5ce24874f8889dd599494e41.svg";
export { ForwardRef as ReactComponent };